import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    coverPhotoContainer: {
        aspectRatio: 0.8,
        width: "100%"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    otherNewsHeader: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    infoContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    dotSeparator: {
        height: 4,
        width: 4
    },
    modalOverlay: {
        justifyContent: "center",
        flex: 1
    },
    closeButton: {
        position: "absolute",
        zIndex: 20
    },
    shareButton: {
        alignSelf: "flex-end"
    },
    coverPhoto: {
        resizeMode: "cover",
        aspectRatio: 0.8,
        width: "100%"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    gmminiIcon: {
        height: 20,
        width: 20
    },
    container: {
        flex: 1
    },
    allText: {
        textTransform: "uppercase"
    }
});
export default stylesheet;
